<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <v-skeleton-loader
        class="skeleton-wrapper sprint-text"
        type="text"
        :loading="isLoading"
        v-if="isLoading"
      ></v-skeleton-loader>
      <h1 class="task-title" v-else>
        Minha Evolução <v-icon>mdi-chart-line</v-icon>
      </h1>
    </div>

    <div v-if="!isLoading">
      <line-chart
        class="line-chart"
        :titulo="tituloGrafico"
        :media="mediaGrafico"
      ></line-chart>
    </div>
    <p style="color: #444444; font-size: 14px">
      *Caso não exista linha traçada em algum dos pontos, significa dizer que a
      avaliação ainda não foi respondida.
    </p>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import LineChart from '@/components/LineChart.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    SnackBar,
    VSkeletonLoader,
    LineChart,
  },
  data() {
    return {
      idProjeto: null,
      tituloGrafico: undefined,
      mediaGrafico: undefined,
      isLoading: true,
    };
  },
  created() {
    this.fetchEvolucao(this.$route.params.id);
  },
  methods: {
    fetchEvolucao(idProjeto) {
      axios
        .get(API_URL + `/avaliacoes/consultarMinhaEvolucao/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          console.log(response.data.mediaAvaliacoes);
          this.tituloGrafico = response.data.mediaAvaliacoes.map(
            (item) => item.titulo,
          );
          this.mediaGrafico = response.data.mediaAvaliacoes.map(
            (item) => item.media,
          );
          console.log(this.tituloGrafico);
          console.log(this.mediaGrafico);

          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);

          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.task-title {
  font-size: 22px;
  font-weight: bold;
}
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.skeleton-wrapper {
  width: 50%;
  background: transparent;
}
.sprint-text {
  font-size: 22px;
  font-weight: bold;
}
.line-chart {
  height: 80vh;
}
</style>
